import React from "react";
import get from "lodash/get";

import { ResponsiveImage } from "@quintype/components";
import { object, array, string, number, bool } from "prop-types";
import cx from "classnames";

import Headline from "../../atoms/headline";

import PhotoIcon from "../icons/photo";

import "./card-image.m.css";

const CardImage = ({
  story = {},
  aspectRatio,
  defaultWidth,
  imageType = "image16x9",
  isStoryPage,
  eagerLoad = false,
  showHeadline,
  headlineProps,
  widths = [250, 480, 764]
}) => {
  const wrapperStyleName = cx(
    "qt-image-dynamic",
    { image16x9: imageType === "image16x9" },
    { image2x1: imageType === "image2x1" },
    { image4x3: imageType === "image4x3" },
    { image1x1: imageType === "image1x1" },
    { image267x332: imageType === "image267x332" }
  );

  const slug = story["hero-image-s3-key"];
  const storyImageSlug = get(story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"], slug);
  const { headerLevel, headerType } = headlineProps || {};

  return (
    <figure styleName={wrapperStyleName} className={wrapperStyleName}>
      <ResponsiveImage
        slug={isStoryPage ? slug : storyImageSlug}
        metadata={story["hero-image-metadata"]}
        aspectRatio={aspectRatio}
        defaultWidth={defaultWidth}
        widths={widths}
        sizes="( max-width: 500px ) 98%, ( max-width: 768px ) 48%, 23%"
        styleName="image"
        className="image"
        eager={eagerLoad}
        alt={story["hero-image-caption"] ? story["hero-image-caption"] : story["headline"]}
      />
      {story["story-template"] === "video" && <div className="video-icon" />}
      {story["story-template"] === "photo" && (
        <div styleName="photo-icon">
          {" "}
          <PhotoIcon />{" "}
        </div>
      )}
      {showHeadline && (
        <div styleName="card-text">
          <Headline story={story} text={story.headline} headerLevel={headerLevel} headerType={headerType} />
        </div>
      )}
    </figure>
  );
};

CardImage.propTypes = {
  story: object,
  aspectRatio: array,
  defaultWidth: number,
  imageType: string,
  isStoryPage: bool,
  eagerLoad: bool,
  widths: array,
  headlineProps: object,
  showHeadline: bool
};

export default CardImage;
